<template>
  <div class="app-container">
    <el-card>
      <!-- 返回按钮 -->
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="user-info-card">
        <img class="avatar" :src="form.headImg" />
        <div class="user-info-content">
          <div class="user-info-row">
            <span class="user-name">{{ form.realName || '-' }}</span>
            <span v-if="form.gender === '女'" class="gender female">♀</span>
            <span v-else-if="form.gender === '男'" class="gender male">♂</span>
            <span class="user-role">{{ form.positionName || '-' }}</span>
          </div>
          <div class="user-phone">主播昵称：{{ form.liveName || '-' }}</div>
          <div class="user-phone">{{ form.userPhone }}</div>
        </div>
      </div>
      <div class="title-box"><span class="txt1">直播基础数据</span></div>
      <el-descriptions>
        <el-descriptions-item label="直播次数">{{ form.liveCount || '-' }}</el-descriptions-item>
        <el-descriptions-item label="直播时长">{{ form.liveTotalSecond || '-' }}</el-descriptions-item>
        <el-descriptions-item label="最近直播时间">{{ form.lastLiveTime || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">直播订单</span></div>
      <el-descriptions>
        <el-descriptions-item label="下单数量">{{ orderCountFormatter || '-' }}</el-descriptions-item>
        <el-descriptions-item label="余额商城订单">{{ form.yueOrderCount || '-' }}</el-descriptions-item>
        <el-descriptions-item label="秒杀订单">{{ form.killOrderCount || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">直播充值</span></div>
      <el-descriptions>
        <el-descriptions-item label="充值次数">{{ form.rechargeCount || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">直播福袋</span></div>
      <el-descriptions>
        <el-descriptions-item label="发放福袋">{{ form.luckyBagCount || '0' }}次</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">直播打赏</span></div>
      <el-descriptions>
        <el-descriptions-item label="打赏次数">{{ form.rewardCount || '0' }}次</el-descriptions-item>
        <el-descriptions-item label="打赏现金支付">{{ form.rewardCash || '0' }}元</el-descriptions-item>
        <el-descriptions-item label="打赏零售价支付">{{ form.rewardCoin || '-' }}</el-descriptions-item>
      </el-descriptions>
      <a href="javascript:;" @click="goRewardRecord">查看打赏记录</a>
      <div class="title-box"><span class="txt1">直播预告</span></div>
      <el-descriptions>
        <el-descriptions-item label="直播预告数量">{{ form.previewCount || '-' }}</el-descriptions-item>
      </el-descriptions>
      <a href="javascript:;" @click="goPreview">查看预告</a>
    </el-card>
  </div>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'
import { Subtr } from '@/utils/index'
export default {
  props: ['rowItem'],
  data() {
    return {
      list: [],
      form: null,
    }
  },
  created() {
    this.form = this.rowItem
    // this.handleShow()
  },
  computed: {
    orderCountFormatter() {
      return Subtr(this.form.killOrderCount, this.form.yueOrderCount)
    }
  },
  methods: {
    handleShow() {
      // sysGoodsApi.fetchById(this.rowItem.id)
      //   .then((res) => {
      //     let data = res.data;
      //     this.form = data
      //   })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }

}
</script>

<style lang="scss" scoped>
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.banner-box {
  width: 50px;
  height: 50px;
  margin: 2px;
}
.user-info-card {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  margin: 16px 0 24px 0;
  width: 420px;
  box-sizing: border-box;
  .avatar {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: #eee;
    margin-right: 24px;
    object-fit: cover;
  }
  .user-info-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .user-info-row {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .user-name {
        font-size: 22px;
        color: #222;
        font-weight: 500;
        margin-right: 8px;
      }
      .gender {
        font-size: 16px;
        margin-right: 8px;
        &.female {
          color: #e43;
        }
        &.male {
          color: #409eff;
        }
      }
      .user-role {
        font-size: 14px;
        color: #409eff;
        background: #eaf6ff;
        border-radius: 4px;
        padding: 2px 8px;
        margin-left: 4px;
      }
    }
    .user-phone {
      font-size: 16px;
      color: #666;
    }
  }
}
</style>
